/**
 * Brand defaults for the engine taker SPA.
 *
 * Single source of truth for visitor-facing brand strings — support email,
 * wordmark, brand name. Any new component (CheckoutPage, future LPs, error
 * pages, etc.) imports from here so we don't drift if these ever change.
 *
 * If this engine instance is ever forked for a non-TSB brand, swap the
 * constants here (or wire them to env vars / per-assessment branding config).
 */

/** Support / help email shown in footers, contact prompts, error states. */
export const SUPPORT_EMAIL = 'support@thesuccessfulbookkeeper.com';

/** Display name of the brand (wordmark text, "Powered by", etc.). */
export const BRAND_NAME = 'The Successful Bookkeeper';

/** Public root URL of the brand site (used for "back to home" links). */
export const BRAND_HOME_URL = 'https://www.thesuccessfulbookkeeper.com';

/** TSB primary brand color (Electric Blue). Used for CTAs + accent. */
export const BRAND_ACCENT = '#2424E6';

/** TSB Global logo (R2 public bucket). Used in standalone pages like BrokenPage. */
export const BRAND_LOGO_URL = 'https://pub-21e4931ef4774e378bca73afe99a4ba4.r2.dev/brands/tsb/logo-light.svg';
